<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-12">
        <h2>Fichas Médicas
        <configTools 
          [rowsExport]="rowsExport"
          [Title]="tituloTabla"
          (AddChange)="add($event)"
          (ImportChange)="import($event)"
          [eliminando]="eliminandoFicha"
          [Permiso]="permisoEdicion"
          ></configTools>
        </h2>
    </div>
</div>
<div *ngIf="!buscandoFichas" class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="header">
        <div class="ibox-content">
          <div>
            <mat-error *ngIf="eliminacionInvalida" class="eliminacionInvalida">{{MensajeError}}</mat-error>
            <div class="table table-striped">
              <p-table #dt [value]="fichas" [rows]="10" [paginator]="true" [globalFilterFields]="['personalNavigation.nombre', 'personalNavigation.apellido', 'rubrosNavigation.descripcion']"
                       [rowHover]="true" dataKey="id"
                       currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} fichas" [showCurrentPageReport]="true">
                <ng-template pTemplate="caption">
                  <div class="p-d-flex p-ai-center p-jc-between">
                    <span class="p-input-icon-left">
                      <i class="pi pi-search"></i>
                      <input pInputText type="text" class="p-inputtext p-component" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Buscar..." />
                    </span>
                  </div>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="personal">Personal <p-sortIcon field="personal"></p-sortIcon></th>
                    <th pSortableColumn="rubro">Rubro <p-sortIcon field="rubro"></p-sortIcon></th>
                    <th pSortableColumn="desde">Desde <p-sortIcon field="desde"></p-sortIcon></th>
                    <th pSortableColumn="hasta">Hasta <p-sortIcon field="hasta"></p-sortIcon></th>
                    <th pSortableColumn="certificado">Certificado <p-sortIcon field="certificado"></p-sortIcon></th>
                    <th pSortableColumn="cantidad">Cantidad <p-sortIcon field="cantidad"></p-sortIcon></th>
                    <th pSortableColumn="diagnostico">Diagnóstico <p-sortIcon field="diagnostico"></p-sortIcon></th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-ficha let-rowIndex="rowIndex">
                  <tr>
                    <td>{{ficha.personalNavigation.legajo}} - {{ficha.personalNavigation.apellido}} {{ficha.personalNavigation.nombre}}</td>
                    <td>{{ficha.rubrosNavigation.descripcion}}</td>
                    <td style="text-align: center;">{{ficha.desde|date:'dd/MM/yyyy'}}</td>
                    <td style="text-align: center;">{{ficha.hasta|date:'dd/MM/yyyy'}}</td>
                    <td class="text-center">
                        <mat-checkbox [(ngModel)]="ficha.certificado" [disabled]=true>
                        </mat-checkbox>
                    </td>
                    <td class="text-right">{{ficha.cantidad}}</td>
                    <td>{{ficha.diagnostico}}</td>
                    <td>
                      <button pButton pRipple pTooltip="Editar" tooltipPosition="bottom" icon="pi pi-pencil" class="btn btn-xs btn-warning" (click)="edit(ficha, rowIndex)"></button>
                      <button *ngIf="permisoEdicion" pButton pRipple pTooltip="Eliminar" tooltipPosition="bottom" icon="pi pi-trash" class="btn btn-xs  btn-danger" (click)="delete(ficha)"></button>
                      <button pButton pRipple pTooltip="Códigos de Nómina" tooltipPosition="bottom" icon="pi pi-sliders-h" class="btn btn-xs  btn-info" (click)="abrirAvances(ficha)"></button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
